import { capitalize } from 'lodash';
import { memo, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { type ThumbnailStyle } from '@air/api/types';
import { ChevronDown } from '@air/next-icons';
import { input } from '@air/primitive-input';

import { useThumbnailPreference } from '~/hooks/useThumbnailPreference';
import { CentralizedBoardSelectors } from '~/store/centralizedBoard/selectors';
import { setThumbnailPreferenceAction } from '~/store/configViews/actions';

const THUMBNAIL_STYLES: ThumbnailStyle[] = ['default', 'contain'];
const GENERIC_BOARD_ID = 'generic';

export const ViewVisibilityThumbnailPreference = memo(() => {
  const dispatch = useDispatch();
  const { getPreference, updatePreference } = useThumbnailPreference();
  const boardId = useSelector(CentralizedBoardSelectors.boardId);
  const value = useMemo(() => getPreference(boardId), [boardId, getPreference]);

  return (
    <>
      <div className="flex items-center justify-between gap-6 px-1.5 py-1">
        <label className="text-14" htmlFor="preferences">
          Thumbnail
        </label>
        <div className={input({ className: 'relative px-0 text-12', size: 'small' })}>
          <select
            id="preferences"
            defaultValue={value}
            className="size-full cursor-pointer appearance-none bg-transparent pr-8 pl-2"
            onChange={(event) => {
              dispatch(setThumbnailPreferenceAction({ thumbnailPreference: event.target.value as ThumbnailStyle }));
              updatePreference(boardId ?? GENERIC_BOARD_ID, event.target.value as ThumbnailStyle);
            }}
            value={value}
          >
            {THUMBNAIL_STYLES.map((option) => (
              <option key={option} value={option}>
                {capitalize(option.replace('-', ' '))}
              </option>
            ))}
          </select>
          <ChevronDown className="pointer-events-none absolute top-1/2 right-2 size-4 -translate-y-1/2" />
        </div>
      </div>
    </>
  );
});

ViewVisibilityThumbnailPreference.displayName = 'ViewVisibilityThumbnailPreference';
